module.exports = __webpack_public_path__ + "img/store.249a38c4.png";